// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
require('./_set-collection-from')('WeakMap');



// WEBPACK FOOTER //
// node_modules/_core-js@2.5.6@core-js/modules/es7.weak-map.from.js